/**
 * La saisie peut temporairement finir avant son debut. Les boutons restent
 * utilisables pour la corriger ; l'ordre est valide lors de l'enregistrement.
 * Seules les bornes de la journee limitent le deplacement.
 */
export function decalerMinutes(minutes: number, delta: number, maximum: number): number | null {
  const suivant = minutes + delta;
  return Number.isFinite(suivant) && suivant >= 0 && suivant <= maximum ? suivant : null;
}
